/**
 * main.js — Módulo principal da landing page Dra. Lissanya
 *
 * Responsável por:
 *  - Inicializar ícones Lucide
 *  - Scroll suave nos botões CTA
 *  - Fallback de animação on-scroll via IntersectionObserver
 *  - Exibir o ano corrente no rodapé
 */ 
/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $56b030ad8f5f7f97$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M5 12h14"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7"
        }
    ]
];

/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $a12c1fcea1de36df$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M8 2v4"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18"
        }
    ]
];

/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $34543018850e6975$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4"
        }
    ]
];

/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $95627eaa9c97a085$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6"
        }
    ]
];

/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $d592b515c0ccaf83$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};


const $6f82ba382b0afa81$var$createSVGElement = ([tag, attrs, children])=>{
    const element = document.createElementNS("http://www.w3.org/2000/svg", tag);
    Object.keys(attrs).forEach((name)=>{
        element.setAttribute(name, String(attrs[name]));
    });
    if (children?.length) children.forEach((child)=>{
        const childElement = $6f82ba382b0afa81$var$createSVGElement(child);
        element.appendChild(childElement);
    });
    return element;
};
const $6f82ba382b0afa81$export$2e2bcd8739ae039 = (iconNode, customAttrs = {})=>{
    const tag = "svg";
    const attrs = {
        ...(0, $d592b515c0ccaf83$export$2e2bcd8739ae039),
        ...customAttrs
    };
    return $6f82ba382b0afa81$var$createSVGElement([
        tag,
        attrs,
        iconNode
    ]);
};



/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $3f08ea90446765bc$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};


/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $9b168f586cc6a0ac$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $948bef066719aefd$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());


const $1f702f2586079a44$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $948bef066719aefd$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};


const $2279f71d3979881f$export$10924a90f5ba4e1c = (element)=>Array.from(element.attributes).reduce((attrs, attr)=>{
        attrs[attr.name] = attr.value;
        return attrs;
    }, {});
const $2279f71d3979881f$export$18505e447a7bb2d5 = (attrs)=>{
    if (typeof attrs === "string") return attrs;
    if (!attrs || !attrs.class) return "";
    if (attrs.class && typeof attrs.class === "string") return attrs.class.split(" ");
    if (attrs.class && Array.isArray(attrs.class)) return attrs.class;
    return "";
};
const $2279f71d3979881f$export$2e2bcd8739ae039 = (element, { nameAttr: nameAttr, icons: icons, attrs: attrs })=>{
    const iconName = element.getAttribute(nameAttr);
    if (iconName == null) return;
    const ComponentName = (0, $1f702f2586079a44$export$6fb43ff9addf7357)(iconName);
    const iconNode = icons[ComponentName];
    if (!iconNode) return console.warn(`${element.outerHTML} icon name was not found in the provided icons object.`);
    const elementAttrs = $2279f71d3979881f$export$10924a90f5ba4e1c(element);
    const ariaProps = (0, $3f08ea90446765bc$export$ab365959aa6deed0)(elementAttrs) ? {} : {
        "aria-hidden": "true"
    };
    const iconAttrs = {
        ...(0, $d592b515c0ccaf83$export$2e2bcd8739ae039),
        "data-lucide": iconName,
        ...ariaProps,
        ...attrs,
        ...elementAttrs
    };
    const elementClassNames = $2279f71d3979881f$export$18505e447a7bb2d5(elementAttrs);
    const className = $2279f71d3979881f$export$18505e447a7bb2d5(attrs);
    const classNames = (0, $9b168f586cc6a0ac$export$3d46f4579dba46e5)("lucide", `lucide-${iconName}`, ...elementClassNames, ...className);
    if (classNames) Object.assign(iconAttrs, {
        class: classNames
    });
    const svgElement = (0, $6f82ba382b0afa81$export$2e2bcd8739ae039)(iconNode, iconAttrs);
    return element.parentNode?.replaceChild(svgElement, element);
};
























































































































































































































































































































































































































































































































































































































































































































































/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebf83158662f72a9$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M12 7v14"
        }
    ],
    [
        "path",
        {
            d: "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"
        }
    ],
    [
        "path",
        {
            d: "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5"
        }
    ],
    [
        "rect",
        {
            x: "3",
            y: "7",
            width: "18",
            height: "4",
            rx: "1"
        }
    ]
];





































































































































































































































/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c79cef5e1c1241e1$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3"
        }
    ]
];


















































































































































































/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $297c835470e51c79$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"
        }
    ],
    [
        "path",
        {
            d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18"
        }
    ],
    [
        "path",
        {
            d: "m2.3 2.3 7.286 7.286"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "2"
        }
    ]
];












































































































/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $400d267d0093a7a0$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
        }
    ],
    [
        "path",
        {
            d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09"
        }
    ],
    [
        "path",
        {
            d: "M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z"
        }
    ],
    [
        "path",
        {
            d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05"
        }
    ]
];
































/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $22fffa0009808487$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M12 3v18"
        }
    ],
    [
        "path",
        {
            d: "m19 8 3 8a5 5 0 0 1-6 0zV7"
        }
    ],
    [
        "path",
        {
            d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1"
        }
    ],
    [
        "path",
        {
            d: "m5 8 3 8a5 5 0 0 1-6 0zV7"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10"
        }
    ]
];











































































































































































































































































































































































/**
 * @license lucide v1.16.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $2dc81f081c6d7f5f$export$2e2bcd8739ae039 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4"
        }
    ]
];



















































































const $5e090255d66e2ae4$export$f8761611413a374e = ({ icons: icons = {}, nameAttr: nameAttr = "data-lucide", attrs: attrs = {}, root: root = document, inTemplates: inTemplates } = {})=>{
    if (!Object.values(icons).length) throw new Error("Please provide an icons object.\nIf you want to use all the icons you can import it like:\n `import { createIcons, icons } from 'lucide';\nlucide.createIcons({icons});`");
    if (typeof root === "undefined") throw new Error("`createIcons()` only works in a browser environment.");
    const elementsToReplace = Array.from(root.querySelectorAll(`[${nameAttr}]`));
    elementsToReplace.forEach((element)=>(0, $2279f71d3979881f$export$2e2bcd8739ae039)(element, {
            nameAttr: nameAttr,
            icons: icons,
            attrs: attrs
        }));
    if (inTemplates) {
        const templates = Array.from(root.querySelectorAll("template"));
        templates.forEach((template)=>$5e090255d66e2ae4$export$f8761611413a374e({
                icons: icons,
                nameAttr: nameAttr,
                attrs: attrs,
                root: template.content,
                inTemplates: inTemplates
            }));
    }
    if (nameAttr === "data-lucide") {
        const deprecatedElements = root.querySelectorAll("[icon-name]");
        if (deprecatedElements.length > 0) {
            console.warn("[Lucide] Some icons were found with the now deprecated icon-name attribute. These will still be replaced for backwards compatibility, but will no longer be supported in v1.0 and you should switch to data-lucide");
            Array.from(deprecatedElements).forEach((element)=>(0, $2279f71d3979881f$export$2e2bcd8739ae039)(element, {
                    nameAttr: "icon-name",
                    icons: icons,
                    attrs: attrs
                }));
        }
    }
};


// ──────────────────────────────────────────────
// Inicialização geral ao carregar o DOM
// ──────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', ()=>{
    $2b6e161c9edcf319$var$inicializarIcones();
    $2b6e161c9edcf319$var$configurarScrollSuave();
    $2b6e161c9edcf319$var$configurarAnimacaoScroll();
    $2b6e161c9edcf319$var$exibirAnoAtual();
});
// ──────────────────────────────────────────────
// 1. Ícones — renderiza todos os ícones Lucide
//    presentes no HTML (atributo data-lucide)
// ──────────────────────────────────────────────
function $2b6e161c9edcf319$var$inicializarIcones() {
    (0, $5e090255d66e2ae4$export$f8761611413a374e)({
        icons: {
            CheckCircle: $34543018850e6975$export$2e2bcd8739ae039,
            Users: $2dc81f081c6d7f5f$export$2e2bcd8739ae039,
            PenTool: $297c835470e51c79$export$2e2bcd8739ae039,
            Scale: $22fffa0009808487$export$2e2bcd8739ae039,
            Gift: $ebf83158662f72a9$export$2e2bcd8739ae039,
            Rocket: $400d267d0093a7a0$export$2e2bcd8739ae039,
            MapPin: $c79cef5e1c1241e1$export$2e2bcd8739ae039,
            ChevronDown: $95627eaa9c97a085$export$2e2bcd8739ae039,
            ArrowRight: $56b030ad8f5f7f97$export$2e2bcd8739ae039,
            Calendar: $a12c1fcea1de36df$export$2e2bcd8739ae039
        }
    });
}
// ──────────────────────────────────────────────
// 2. Scroll suave — todos os botões CTA que
//    apontam para #inscricao rolam suavemente
// ──────────────────────────────────────────────
function $2b6e161c9edcf319$var$configurarScrollSuave() {
    const botoesCta = document.querySelectorAll('.btn-cta[href="#inscricao"]');
    botoesCta.forEach((botao)=>{
        botao.addEventListener('click', (evento)=>{
            evento.preventDefault();
            const secaoInscricao = document.querySelector('#inscricao');
            if (secaoInscricao) secaoInscricao.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });
}
// ──────────────────────────────────────────────
// 3. Animação ao scroll — fallback com
//    IntersectionObserver para navegadores que
//    não suportam scroll-driven animations
//    (animation-timeline: view())
// ──────────────────────────────────────────────
function $2b6e161c9edcf319$var$configurarAnimacaoScroll() {
    // Só utiliza o observer se scroll-driven animations NÃO forem suportadas
    if (!CSS.supports('animation-timeline: view()')) {
        // Sinaliza ao CSS que o JS vai controlar a animação
        document.body.classList.add('js-animate-ready');
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        document.querySelectorAll('.animate-on-scroll').forEach((el)=>observer.observe(el));
    }
}
// ──────────────────────────────────────────────
// 4. Ano atual — insere o ano corrente no
//    elemento #current-year do rodapé
// ──────────────────────────────────────────────
function $2b6e161c9edcf319$var$exibirAnoAtual() {
    const spanAno = document.getElementById('current-year');
    if (spanAno) spanAno.textContent = new Date().getFullYear();
}


//# sourceMappingURL=dra-lissanya.7cac558d.js.map
